import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import { usePortalRoot } from "./portalRootContext";
import { cn } from "../../../lib/utils";
export function TooltipProvider({ delayDuration = 0, ...props }) {
    return (_jsx(TooltipPrimitive.Provider, { "data-slot": "tooltip-provider", delayDuration: delayDuration, ...props }));
}
export function Tooltip({ ...props }) {
    return (_jsx(TooltipProvider, { children: _jsx(TooltipPrimitive.Root, { "data-slot": "tooltip", ...props }) }));
}
export function TooltipTrigger({ ...props }) {
    return _jsx(TooltipPrimitive.Trigger, { "data-slot": "tooltip-trigger", ...props });
}
export function TooltipContent({ className, sideOffset = 0, children, ...props }) {
    const portalRoot = usePortalRoot();
    return (_jsx(TooltipPrimitive.Portal, { container: portalRoot ?? undefined, children: _jsxs(TooltipPrimitive.Content, { "data-slot": "tooltip-content", sideOffset: sideOffset, className: cn("bg-foreground text-background animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 w-fit origin-(--radix-tooltip-content-transform-origin) rounded-md px-3 py-1.5 text-xs text-balance", className), ...props, children: [children, _jsx(TooltipPrimitive.Arrow, { className: "bg-foreground fill-foreground z-50", 
                    // Keep the arrow geometry in inline styles so consumers embedding the
                    // chat UI (for example the widget bundle) do not depend on Tailwind
                    // emitting arbitrary-value utilities like size-2.5/translate-y-[...].
                    style: {
                        display: "block",
                        width: "0.625rem",
                        height: "0.625rem",
                        transform: "translateY(calc(-50% - 2px)) rotate(45deg)",
                        borderRadius: "2px",
                    } })] }) }));
}
//# sourceMappingURL=PortalTooltip.js.map